import React, { ReactElement } from "react";

import { ReactComponent as Close } from "../../assets/icons/close-monochrome.svg";
import { ReactComponent as Unmute } from "../../assets/icons/volume-high.svg";
import { ReactComponent as Mute } from "../../assets/icons/volume-mute.svg";
import Button from "../Button";
import ControlsContainer from "../ControlsContainer";
import HelpPopup from "../HelpPopup/HelpPopup.container";

export type Props = {
  readonly quitGame: () => void;
  readonly toggleMute: () => void;
  readonly isBgMusicMuted: boolean;
};

const Controls = ({
  quitGame,
  toggleMute,
  isBgMusicMuted,
}: Props): ReactElement => (
  <ControlsContainer>
    <HelpPopup />
    <Button onClick={quitGame} aria-label="Stop het spel" Icon={Close} />
    <Button
      onClick={toggleMute}
      aria-label={
        isBgMusicMuted ? "Speel achtergrondmuziek" : "Demp achtergrondmuziek"
      }
      Icon={isBgMusicMuted ? Unmute : Mute}
      children={isBgMusicMuted ? "Speel muziek" : "Demp muziek"}
    />
  </ControlsContainer>
);

export default React.memo(
  Controls,
  (prevProps, nextProps) =>
    prevProps.isBgMusicMuted === nextProps.isBgMusicMuted
);
